import { render, staticRenderFns } from "./LearningCardImageInfo.vue?vue&type=template&id=05313104&"
import script from "./LearningCardImageInfo.vue?vue&type=script&lang=js&"
export * from "./LearningCardImageInfo.vue?vue&type=script&lang=js&"
import style0 from "./LearningCardImageInfo.vue?vue&type=style&index=0&id=05313104&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports